export default "__VITE_ASSET__54e12a8f__"